<template>
    <div>
        <highcharts :options="chartOptions" ref="lineCharts" :constructor-type="'chart'"></highcharts>
    </div>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import Highcharts from 'highcharts'
    import HighchartsMore from 'highcharts/highcharts-more'

    HighchartsMore(Highcharts)
    export default {
        name: 'BarChart',
        components: {
            highcharts: Chart
        },
        props: ['options'],
        data() {
            return {
                chartOptions: Highcharts.merge(this.options, {
                    colors: ['#756aa0', '#53b7a9', '#338089', '#2298dd'],
                    title: {
                        enabled: false,
                        text: ''
                    },
                    chart: {
                        type: 'bar'
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                enabled: true,
                                inside: true,
                                style: {
                                    color: 'white',
                                    fontSize: '15px'
                                }
                            }
                        }
                    }

                })
            }
        }
    }

</script>

<style scoped>

</style>
